'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');

module.exports = function () {
    $('[data-language-selector]').each(function () {
        var $this = $(this);
        var numberOfOptions = $this.children('option').length;

        // Oculta el select original
        $this.addClass('s-hidden');
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="styled-select"></div>');

        var $styledSelect = $this.next('div.styled-select');
        var selectedItem;

        // Encuentra el ítem seleccionado
        for (var j = 0; j < numberOfOptions; j++) {
            if ($this.children('option').eq(j).attr('selected')) {
                selectedItem = $this.children('option').eq(j);
            }
        }

        var styledItemImg = '<img class="country-flag" src="' + selectedItem.val() + '" alt="' + selectedItem.text() + '" />';
        var styledItemText = '<span class="country-text">' + selectedItem.text() + '</span>';
        $styledSelect.html(styledItemImg + styledItemText);

        // Crea la lista visual de opciones
        var $list = $('<ul />', {
            class: 'options'
        }).insertAfter($styledSelect);

        for (var i = 0; i < numberOfOptions; i++) {
            var $option = $this.children('option').eq(i);
            var path = $option.attr('data-locale-path');
            var localeCode = $option.attr('data-locale');
            var currencyCode = $option.attr('data-currencycode');

            var img = '<img class="country-flag" src="' + $option.val() + '" alt="' + $option.text() + '" />';
            var text = '<span class="country-text">' + $option.text() + '</span>';

            var $item = $('<li class="options-item" tabindex="0" role="option" aria-label="' + $option.text() + '" />')
                .html(img + text)
                .data({
                    locale: localeCode,
                    currencycode: currencyCode
                });

            $list.append($item);
        }

        var $listItems = $list.children('li');

        $styledSelect.click(function (e) {
            e.stopPropagation();
            $('div.styled-select.active').not(this).removeClass('active').next('ul.options').hide();
            $(this).toggleClass('active').next('ul.options').toggle();
        });

        $listItems.on('click keypress', function (e) {
            if (e.type === 'click' || e.key === 'Enter') {
                var localeCode = $(this).data('locale');
                var currencyCode = $(this).data('currencycode');
                var queryString = $('.page').data('querystring');
                var action = $('.page').data('action');
                var url = $('.country-selector').data('url');

                $styledSelect.html($(this).html()).removeClass('active');
                $list.hide();

                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: {
                        code: localeCode,
                        queryString: queryString,
                        CurrencyCode: currencyCode,
                        action: action
                    },
                    success: function (response) {
                        $.spinner().stop();
                        if (response && response.redirectUrl) {
                            window.location.href = response.redirectUrl;
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });

        $(document).click(function () {
            $styledSelect.removeClass('active');
            $list.hide();
        });

        // Accesibilidad con teclado
        keyboardAccessibility('.styled-select', {
            40: function ($options) { // down
                if ($(this).is(':focus')) {
                    $options.first().focus();
                } else {
                    $(':focus').next().focus();
                }
            },
            38: function ($options) { // up
                if ($options.first().is(':focus') || $(this).is(':focus')) {
                    $(this).focus();
                    $(this).removeClass('active');
                } else {
                    $(':focus').prev().focus();
                }
            },
            27: function () { // escape
                $(this).removeClass('active').next('ul.options').hide();
            },
            9: function () { // tab
                $(this).removeClass('active').next('ul.options').hide();
            }
        }, function () {
            return $(this).next('ul.options').children('li');
        });
    });
};
